/**
* 品牌 - 企业资讯、最新活动、时尚资讯 模块详情页 组件
*/
<template>
  <div :class="getName">
    <h1>{{ArticleData.Title}}</h1>
    <time>{{ArticleData.FBSJ}}</time>
    <article class="h-article" v-html="ArticleData.NewsContent">
      <!-- <p>上帝说，要有光，于是便有了光。农历丙申猴年，煌明煌年方二八，意气风发。盈盈芳龄，煌明煌珠宝鼎立中原，立志进军巍巍九州。凌飞在即，吾等精英当内修圣王，外拓域疆，乘风破浪，剑指苍穹。《耀•有光》煌明煌珠宝2015年表彰大会暨新春联欢会，于2016年1月15日隆重举办。下面一同来
回顾下彼时的荣誉和姿彩。</p>
      <img src="@/assets/img/zujin1.jpg" />
      上帝说，要有光，于是便有了光。农历丙申猴年，煌明煌年方二八，意气风发。盈盈芳龄，煌明煌珠宝鼎立中原，立志进军巍巍九州。凌飞在即，吾等精英当内修圣王，外拓域疆，乘风破浪，剑指苍穹。《耀•有光》煌明煌珠宝2015年表彰大会暨新春联欢会，于2016年1月15日隆重举办。下面一同来
回顾下彼时的荣誉和姿彩。
      <img src="@/assets/img/banner1.jpg" /> -->
    </article>
  </div>
</template>
<script>
//import { footerList } from '@/mock' // 脚部数据
import { articleDetail } from '@/api'

export default {
  name: 'DetailsPage',
  props: {},
  data () {
    return {
      terminal: '', // 终端类型
      id:this.$route.params.id,
      ArticleData : [],
    }
  },
  computed: {
    getName(){
      if(this.terminal === 'pc'){
        return 'h-details mb20'
      } else {
        return 'h-details mb20 h-ph'
      }
    }
  },
  created () {
    this.terminal = localStorage.getItem('terminalm')
    console.log('this.terminal***', this.terminal)
     this.getArticleData() // 底部数据加载
  },
  mounted () {
    //this.footerData = footerList.result // 使用接口时 此处删除
  },
  methods: {
    getArticleData () {
      const params = { // 请求参数 --- 根据情况 是否需要
        id:this.id
      }
      articleDetail(params).then(res => {
        this.ArticleData = res
      })
    },
  }
}
</script>

<style lang="scss" scoped>
  .h-details {
    width: 800px;
    h1{
      margin: 10px 0 20px 0;
      font-size: 16px;
      color: #000;
    }
    time{
      display: block;
      padding-bottom: 10px;
      color: #000;
    }
  }
  .h-article{
    text-indent: 2em;
    line-height: 20px;
    p{
      color: #666;
    }
    img{
      width: 100%;
      margin: 5px 0;
    }
  }
//   img {
//     -webkit-box-sizing: border-box;
//     -moz-box-sizing: border-box;
//     box-sizing: border-box;
//     max-width: 100%;
//     height: auto;
//     vertical-align: middle;
//     border: 0;
// }
  /* 移动端 */
  .h-details.h-ph{
    width: 100%;
    padding: 0 15px;
    box-sizing: border-box;
    .h-article{
    text-indent: 0em !important;
    line-height: 20px;
    
  }
 /deep/  p{
    text-indent: 0em !important;
  }
    .simg{
       max-width: 100% !important;
    }
    /deep/ img{
      max-width: 100% !important;
    }
  }
</style>
